import React, { Component } from 'react';
import T from 'i18n-react';
import { orange500, grey50, grey300, teal300, red400 } from 'material-ui/styles/colors';

// Material ui 
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import { setCookie } from '../../../utils/CookieUtils';
import UserService from '../../../services/UserService';

// Enum 
import PAGES from '../../../enums/PageEnum';
import COOKIES from '../../../enums/CookieEnum';
import HttpCodes from '../../../enums/HttpCodes';

const styles = {
    errorStyle: {
        color: orange500,
    },
    underlineStyle: {
        borderColor: orange500,
    },
    hintStyle: {
        color: grey300,
    },
    inputStyle: {
        color: grey50,
    },
    floatingLabelStyle: {
        color: grey300,
    },
    floatingLabelFocusStyle: {
        color: grey300,
    },
    labelStyle: {
        fontWeight: '100',
        letterSpacing: '2px',
    }
};

const MATCHING_NUMERIC = '[0-9]';
const MATCHING_CHAR = '[a-zA-Z]';

class FirstConnexion extends Component {

    /*************************************************
     * **************** LifeCycle ********************
     *************************************************/
    constructor(props) {
        super(props);
        let keyPass = this.props.location.pathname.split("/");
        keyPass = keyPass[keyPass.length - 1];
        this.state = {
            login: "",
            password: "",
            confirmPassword: "",
            keyPass: keyPass
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.validAction = this.validAction.bind(this);
    }
    
    render() {
        return(
                <form onSubmit={this.validAction}>
                    <h1>{T.translate("login.firstConnexion.label")} {this.state.error}</h1>
                    { this.state.error &&
                        <span className="error" style={{color:red400}}>{T.translate(this.state.errorMessage)}</span>
                    }
                    <TextField id="loginFieldControlledFirst"
                                name="login"
                                hintText={T.translate("login.username")}
                                floatingLabelText={T.translate("login.username")}
                                fullWidth={true}
                                hintStyle={styles.hintStyle}
                                floatingLabelStyle={styles.floatingLabelStyle}
                                floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                inputStyle={styles.inputStyle}
                                value={this.state.login}
                                onChange={this.handleInputChange.bind(this)}/>
                    <TextField id="passwordFieldControlledFirst"
                                name="password"
                                hintText={T.translate("login.password")}
                                floatingLabelText={T.translate("login.password")}
                                fullWidth={true}
                                hintStyle={styles.hintStyle}
                                floatingLabelStyle={styles.floatingLabelStyle}
                                floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                inputStyle={styles.inputStyle}
                                type="password"
                                value={this.state.password}
                                onChange={this.handleInputChange.bind(this)}/>
                    <TextField id="confirmPasswordFieldControlledFirst"
                                name="confirmPassword"
                                hintText={T.translate("login.confirmPassword")}
                                floatingLabelText={T.translate("login.confirmPassword")}
                                fullWidth={true}
                                floatingLabelStyle={styles.floatingLabelStyle}
                                hintStyle={styles.hintStyle}
                                floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                inputStyle={styles.inputStyle}
                                type="password"
                                value={this.state.confirmPassword}
                                onChange={this.handleInputChange.bind(this)}/>
                    <RaisedButton label={T.translate("login.confirm")} secondary backgroundColor={teal300} labelColor={grey50} className="sign-in-button" type="submit" />
                </form>
        );
    }

    /**********************************************************
     * **************** Actions composants ********************
     **********************************************************/

     validAction(e) {
        e.preventDefault();
        let formValid = this.isFormValid()
        if(formValid) {
            UserService.setNewPassword(this.state.keyPass, this.state.login, this.state.password).then((data) => {
                if(data && data.token) {
                    setCookie({name: COOKIES.SID, value: data.token});
                    this.props.router.push(PAGES.HOME_PAGE);
                } else {
                    this.setState({
                        error: true,
                        errorMessage: 'login.error'
                    });
                }
            }).catch((error) => {
                switch (error.status) {
                    case HttpCodes.UNAUTHORIZED :
                        this.props.router.push(PAGES.LOGIN_PAGE);
                        break
                    default:
                        this.setState({
                            error: true,
                            errorMessage: 'login.error'
                        });
                        break
                }
            })
        }
     }

     handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            error: false
        });
     }

     isFormValid() {
         if(!this.state.login || this.state.login === '' ) {
             this.setState({
                 error: true,
                 errorMessage: 'login.error'
             })
             return false
         }
        return this.isPasswordCorrect()
     }
    
     /**
      * Vérifie si le password est conforme au régle
      */
     isPasswordCorrect() {
        if(this.state.password !== this.state.confirmPassword) {
            this.setState({
                error: true,
                errorMessage: 'login.firstConnexion.missMatchPassword'
            })
            return false;
        }

        if(this.state.password.length < 8 || this.state.password.length > 256) {
            this.setState({
                error: true,
                errorMessage: 'login.firstConnexion.password'
            })
            return false;
        }

        if(!this.state.password.match(MATCHING_CHAR) || !this.state.password.match(MATCHING_NUMERIC)) {
            this.setState({
                error: true,
                errorMessage: 'login.firstConnexion.password'
            })
            return false
        }

        return true
     }
     

    
}

export default (FirstConnexion);



// WEBPACK FOOTER //
// ./src/ui/connexion/firstConnexion/FirstConnexion.js